// extracted by mini-css-extract-plugin
module.exports = {"App":"help_App__2RgxE","help_icon":"help_help_icon__3RqFf","help_icon1":"help_help_icon1__23zNp","dropdown":"help_dropdown__1gSn6","dropdown_value":"help_dropdown_value__3DA6X"};